import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import { getCurrentInstance, onMounted, reactive, toRefs } from "vue";
import apis from "@/api";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { encryption, access } from "@/utils/aesEncrypt.js";
import { ACCESS_TOKEN, USERINFO, USER_AUTH, USER_AUTH_URL } from "@/store/mutation-types";
export default {
  name: "login",
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const store = useStore();
    const data = reactive({
      phone: "",
      verifyCode: "",
      captchaCode: "",
      errors: {},
      btnTitle: "获取验证码",
      captcha: {},
      disabled: false,
      loginType: '2',
      // phone手机短信验证 pwd密码
      account: '',
      password: ''
    });
    const validatePhone = () => {
      //判断输入的手机号是否合法
      if (!data.phone) {
        ElMessage.warning("手机号码不能为空");
        return false;
      } else if (!/^1[345678]\d{9}$/.test(data.phone)) {
        ElMessage.warning("请输入正确手机号");
        return false;
      } else if (!data.captchaCode) {
        ElMessage.warning("请输入图形验证码");
        return false;
      } else {
        data.errors = {};
        return true;
      }
    };
    const validateBtn = () => {
      //倒计时
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          data.disabled = false;
          data.btnTitle = "获取验证码";
        } else {
          data.btnTitle = time + "秒后重试";
          data.disabled = true;
          time--;
        }
      }, 1000);
    };
    const getVerifyCode = () => {
      if (validatePhone()) {
        validateBtn();
        apis.sendSms({
          mobile: encryption(data.phone, access.key, access.iv),
          key: data.captcha.key,
          captchaCode: data.captchaCode
        }).then(res => {
          if (res.success) {} else {
            ElMessage.error(res.msg);
            getCaptchaHandler();
          }
        });
      }
    };
    const getPermissionList = () => {
      apis.getUserPermission().then(res => {
        if (res.success) {
          sessionStorage.setItem(USER_AUTH, JSON.stringify(res.data.paramsList));
          sessionStorage.setItem(USER_AUTH_URL, JSON.stringify(res.data.urlList));
          router.push("/home");
        } else {
          ElMessage.error("获取用户权限异常");
        }
      });
    };
    const login = params => {
      apis.login(params).then(res => {
        if (res.success) {
          window.localStorage.setItem(ACCESS_TOKEN, res.data.token);
          window.localStorage.setItem(USERINFO, JSON.stringify(res.data));
          store.commit("setUserInfo", res.data);
          // 获取用户权限
          getPermissionList();
        } else {
          console.log(res.msg);
          ElMessage.error(res.msg);
          getCaptchaHandler();
        }
      });
    };
    const verifyLogin = () => {
      if (!data.phone) {
        return ElMessage.warning("手机号码不能为空");
      }
      if (!data.verifyCode) {
        return ElMessage.warning("短信验证码不能为空");
      }
      if (!data.captchaCode) {
        return ElMessage.warning("图形验证码不能为空");
      }
      login({
        mobile: encryption(data.phone, access.key, access.iv),
        password: data.verifyCode,
        key: data.captcha.key,
        captchaCode: data.captchaCode,
        loginType: data.loginType
      });
    };
    const accountLogin = () => {
      if (!data.account) {
        return ElMessage.warning("用户名不能为空");
      }
      if (!data.password) {
        return ElMessage.warning("密码不能为空");
      }
      login({
        password: encryption(data.password, access.key, access.iv),
        account: data.account,
        mobile: data.account,
        loginType: data.loginType,
        isExternal: 1
      });
    };
    const handleLogin = () => {
      if (data.loginType === '1') {
        verifyLogin();
      } else {
        accountLogin();
      }
    };
    const getCaptchaHandler = () => {
      apis.getCaptcha().then(res => {
        // console.log(res)
        if (res.success) {
          data.captcha = res.data;
        }
      });
    };
    onMounted(() => {
      data.verifyCode = "";
      getCaptchaHandler();
    });
    return {
      ...toRefs(data),
      getVerifyCode,
      validatePhone,
      validateBtn,
      handleLogin,
      getCaptchaHandler
    };
  }
};